const varanasiItinerary = {
  slug:"varanasi-spiritual",

  title: "Spiritual Varanasi Retreat",
  duration: "3 days",
  location: "Varanasi, India",
  difficulty: "Easy",
  priceRange: "$ (Budget)",
  bestTime: "October to March",
  description:
    "Experience India’s spiritual heart with ghats, Ganga Aarti, ancient temples, and sacred rituals.",

  highlights: [
    "Ganga Aarti at Dashashwamedh Ghat",
    "Sunrise boat ride on Ganges",
    "Kashi Vishwanath Temple",
    "Sarnath Buddhist heritage",
    "Old city alleys & ghats"
  ],

  image:
    "https://images.unsplash.com/photo-1583301286816-f4f05e3a1e5e",

  days: [
    {
      day: 1,
      title: "Arrival & Evening Aarti",
      places: [
        "Lal Bahadur Shastri International Airport",
        "Varanasi City",
        "Dashashwamedh Ghat",
        "Ganges River",
        "Godowlia Market"
      ],
      activities: [
        "Arrival in Varanasi",
        "Hotel check-in and rest",
        "Evening walk in old city lanes",
        "Ganga Aarti at Dashashwamedh Ghat"
      ],
      accommodation: "City hotel",
      meals: "Dinner included"
    },
    {
      day: 2,
      title: "Spiritual Exploration",
      places: [
        "Assi Ghat",
        "Manikarnika Ghat",
        "Kashi Vishwanath Temple",
        "Kaal Bhairav Temple",
        "Sarnath",
        "Dhamek Stupa",
        "Sarnath Museum"
      ],
      activities: [
        "Sunrise boat ride on the Ganges",
        "Visit Kashi Vishwanath Temple",
        "Explore Manikarnika Ghat (cremation rituals)",
        "Visit Kaal Bhairav Temple",
        "Excursion to Sarnath (Buddhist site)"
      ],
      accommodation: "City hotel",
      meals: "Breakfast included"
    },
    {
      day: 3,
      title: "Ghats Walk & Departure",
      places: [
        "Tulsi Ghat",
        "Harishchandra Ghat",
        "Banaras Hindu University",
        "Bharat Kala Bhavan Museum",
        "Lal Bahadur Shastri International Airport"
      ],
      activities: [
        "Morning walk along ghats",
        "Visit Banaras Hindu University",
        "Explore Bharat Kala Bhavan Museum",
        "Last-minute souvenir shopping",
        "Departure"
      ],
      accommodation: "N/A",
      meals: "Breakfast included"
    }
  ],

  inclusions: [
    "2 nights accommodation",
    "Boat ride on Ganges",
    "Temple visits"
  ],

  exclusions: [
    "Travel tickets",
    "Personal expenses"
  ],

  tips: [
    "Dress modestly for temples and ghats",
    "Attend early morning rituals for best experience",
    "Keep belongings safe in crowded areas",
    "Photography restricted at some ghats and temples"
  ],

  budget: {
    total: "₹8,000–12,000 per person"
  }
};

export default varanasiItinerary;
